import { render } from "./TableRow.vue?vue&type=template&id=2b2a4dd4&scoped=true"
const script = {}

import "./TableRow.vue?vue&type=style&index=0&id=2b2a4dd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2a4dd4"]])

export default __exports__